import { createFileRoute } from '@tanstack/react-router'

import { SubscriptionFunnelTextsDocumentationPage } from '../../../../components/pages/backoffice/platform/platform-documentation/subscription-funnel-texts-documentation-page.tsx'

export const Route = createFileRoute('/bo/documentation/subscription-funnel-texts')({
  component: () => <SubscriptionFunnelTextsDocumentationPage />,
})
